import { createSelector } from 'reselect'
import { RootState } from 'stores'
import { IApiState } from './types'

export const apiStateSelector = (state: RootState) => state.rp4.api

export const isApiLoading = createSelector<RootState, IApiState, boolean>([apiStateSelector], (state: IApiState) => state.loading)